import { instance } from "api/apiBase";
import {
  LeadSavedView,
  LeadViewColumns,
  LeadViewFilters
} from "shared/app/LeadsTableView/types";

const BASE_URL = "/portal/v1/boom_crm/lead_saved_views";

// Wire shape returned by the Portal API (snake_case, Grape default). `columns`
// may come back null/absent when a view was saved without columns.
interface LeadSavedViewDto {
  id: number;
  name: string;
  filters: LeadViewFilters | null;
  columns: LeadViewColumns | null;
  created_at: string;
  updated_at: string;
}

export interface SaveViewPayload {
  name: string;
  filters: LeadViewFilters;
  columns?: LeadViewColumns;
}

// Partial — a single PUT serves both rename (name only) and overwrite
// (filters/columns). Only the keys provided are touched server-side.
export interface UpdateViewPayload {
  name?: string;
  filters?: LeadViewFilters;
  columns?: LeadViewColumns;
}

const toModel = (dto: LeadSavedViewDto): LeadSavedView => ({
  id: dto.id,
  name: dto.name,
  filters: dto.filters ?? {},
  columns: dto.columns ?? {},
  createdAt: dto.created_at,
  updatedAt: dto.updated_at
});

export const leadSavedViewsApi = {
  list: async (): Promise<LeadSavedView[]> => {
    const { data } = await instance.get<LeadSavedViewDto[]>(BASE_URL);
    return data.map(toModel);
  },

  create: async (payload: SaveViewPayload): Promise<LeadSavedView> => {
    const { data } = await instance.post<LeadSavedViewDto>(BASE_URL, payload);
    return toModel(data);
  },

  update: async (
    id: number,
    payload: UpdateViewPayload
  ): Promise<LeadSavedView> => {
    const { data } = await instance.put<LeadSavedViewDto>(
      `${BASE_URL}/${id}`,
      payload
    );
    return toModel(data);
  },

  remove: async (id: number): Promise<void> => {
    await instance.delete(`${BASE_URL}/${id}`);
  }
};
